import { Controller } from "@hotwired/stimulus"

// Cookbook cover editor: switches between the "Photo" (upload your own) and
// "Pattern" (built-in motif) sections based on the cover_style radio, so only
// the relevant controls show. CSP-safe — toggles a `hidden` class, no inline JS.
export default class extends Controller {
  static targets = ["styleRadio", "photoSection", "patternSection"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.styleRadioTargets.find((radio) => radio.checked)
    const showPattern = selected?.value === "pattern"
    this.patternSectionTargets.forEach((el) => el.classList.toggle("hidden", !showPattern))
    this.photoSectionTargets.forEach((el) => el.classList.toggle("hidden", showPattern))
  }
}
